export default __webpack_public_path__ + "images/7b8c45eeac31f05be286240437cff8e9-halloweenhaunt_small.webp";